<div class="contPop1 center-items m-bot-i">
  <div class="text-pup m-top-i">
    Validación realizada con <span class="f-w"> éxito</span>
    <img class="img-pop" src="assets/images/claro-lines.png">
  </div>
  <div>
    <button class="btmMaterial3 btmAlert on " (click)="continue();" >
      Procesar Orden&nbsp;&nbsp;
      <i aria-hidden="true" class="fa fa-angle-right">
      </i>
    </button>
  </div>
</div>
